import { api } from "./auth";

/**
 * Create a rating for a user (partner or agency)
 * Must be connected with the user to rate them
 * @param {number} ratedUserId - The user ID to rate
 * @param {number} rating - Rating value (1-5)
 * @param {string} feedbackMessage - Optional feedback message
 */
export async function createRating(ratedUserId, rating, feedbackMessage = "") {
  const response = await api.post("/ratings/", {
    rated_user_id: ratedUserId,
    rating: rating,
    feedback_message: feedbackMessage
  });
  return response.data;
}

/**
 * Get all ratings for a specific user
 * @param {number} userId - User ID to get ratings for
 * @param {number} skip - Number of records to skip (pagination)
 * @param {number} limit - Number of records to return (pagination)
 */
export async function getUserRatings(userId, skip = 0, limit = 50) {
  const response = await api.get(`/ratings/user/${userId}`, {
    params: { skip, limit }
  });
  return response.data;
}

/**
 * Get rating statistics for a user
 * @param {number} userId - User ID to get stats for
 */
export async function getUserRatingStats(userId) {
  const response = await api.get(`/ratings/user/${userId}/stats`);
  return response.data;
}

/**
 * Get ratings received by current user
 * @param {number} skip - Number of records to skip (pagination)
 * @param {number} limit - Number of records to return (pagination)
 */
export async function getMyRatings(skip = 0, limit = 50) {
  const response = await api.get("/ratings/my-ratings", {
    params: { skip, limit }
  });
  return response.data;
}
